
import { defineComponent } from "vue";
import Spinner from "@/components/UI/Spinner.vue";

export default defineComponent({
  name: "Button",
  components: {
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    empty: {
      type: Boolean,
      required: false,
    },
    outlined: {
      type: Boolean,
      required: false,
    },
  },
});
